import React, { useState, useEffect } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import http from '../../shared/http';

const EnhancedAdDspSelect = props => {
  const [dsps, setDsps] = useState([]);

  useEffect(() => {
    http.get('/api/internal/dsps').then(({ data }) => {
      setDsps(data);
    });
  }, []);

  useEffect(() => {
    if (props.activeDspId) {
      setActiveDsp(props.activeDspId);
    }
  }, [dsps]);

  const setActiveDsp = dspId => {
    const dsp = dsps.find(dsp => {
      return dsp.id === dspId;
    });

    dsp && props.onDspChange(dsp);
  };

  return (
    <FormControl className="enhanced-ad_dsp-form-control">
      <InputLabel htmlFor="dsp">Select a DSP</InputLabel>
      <Select
        className="enhanced-ad_dsp-select"
        inputProps={{ id: 'dsp' }}
        value={props.activeDspId}
        onChange={evt => setActiveDsp(evt.target.value)}
        data-testid="dsp-select"
      >
        {dsps.map(dsp => (
          <MenuItem value={dsp.id} key={dsp.id}>
            {dsp.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

EnhancedAdDspSelect.propTypes = {
  onDspChange: PropTypes.func.isRequired,
  activeDspId: PropTypes.number
};

EnhancedAdDspSelect.defaultProps = {
  activeDspId: -1
};

export default EnhancedAdDspSelect;
